import { Globe } from 'lucide-react';
import { useDeliveryRegionStore, type DeliveryRegion } from '../store/deliveryRegionStore';

// 收貨地區切換器（地址為王——客人 2026-09-05 業務規則第二條）：
// 用戶可隨時切換收貨地址，可購買商品範圍即時更新（海外＝隱藏僅本地可售商品）。
export default function RegionSwitcher({ className = '' }: { className?: string }) {
  const deliveryRegion = useDeliveryRegionStore((s) => s.deliveryRegion);
  const setDeliveryRegion = useDeliveryRegionStore((s) => s.setDeliveryRegion);

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Globe size={16} className="text-stone-400 pointer-events-none" />
      <select
        value={deliveryRegion || ''}
        onChange={(e) => setDeliveryRegion((e.target.value || null) as DeliveryRegion | null)}
        className="p-2 border border-stone-200 rounded-xl text-sm focus:ring-2 focus:ring-x1493-primary outline-none"
        aria-label="收貨地區"
        title="設定收貨地區後，只顯示可寄送該地區的商品"
      >
        <option value="">收貨地區：未設定</option>
        <option value="HK">香港（香港島）</option>
        <option value="KLN">香港（九龍）</option>
        <option value="NT">香港（新界）</option>
        <option value="OS">海外</option>
      </select>
    </div>
  );
}
